/* eslint-disable no-console */
import Layer from 'services/models/Layer';
import geoAlert from 'services/utils/alert';

import SimpleModal from './components/SimpleModal';

import layerStyles from 'views/MapView/services/symbologiesStyles.json';

import Button from '@material-ui/core/Button';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';
/**
 * Importação do componente GeoBahiaLoader, responsavel
 * por carregar um gif enquanto o sistema esta processando.
 */
import GeoBahiaLoader from 'components/GeoBahiaLoader';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 * 
 * useMemo é um hook que retorna um valor memorizado.
 */
import { useEffect, useState, useCallback, useMemo } from 'react';
/**
 * useHistory é um hook utilizado para redirecionar para outra pagina.
 */
import { useHistory } from 'react-router-dom';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 * 
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useMap, useModule } from 'views/MapView/hooks';

const SEIA = ({ ...props }) => {
  const [section, setSection] = useState(null);
  const [action, setAction] = useState(null);
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [idApp, setIdApp] = useState(null);
  const [cod, setCod] = useState(null);
  const [idLoc, setIdLoc] = useState(null);
  const [token, setToken] = useState(null);
  const [xy, setXy] = useState(null);
  const [nomeImovel, setNomeImovel] = useState('');
  const [degradedArea, setDegradedArea] = useState(0);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const position = useMemo(
    () => ({
      x: window.innerWidth - 400 - window.innerWidth / 2,
      y: 100 - window.innerHeight / 2,
    }),
    []
  );

  const { addLayer, map, layers, changeSelectedLabelColumn, changeStatusLabelVisible } = useMap();
  const { setElement } = useModule();

  // Add geometries as Layers to map
  /**
   * useCallback
   * 
   * @param {*} geojson
   * @param {string} style
   * @param {string} name
   * @param {*} type
   */
  const addGeoJSONLayer = useCallback(
    (geojson, style, name, paramType) => {
      const customRender = L.canvas({ pane: 'mixedPane' });

      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: style,
      };      
      if (geojson[0].geometry.type === "Point") {
        options = {
          ...options,
          pointToLayer: function (feature, latlng) {
            var circleMarker = L.circleMarker(latlng, {
              pane: 'mixedPane',
              ...style,
              renderer: customRender,
            });          
            return circleMarker;
          },
        };
      }      

      const geoJsonLayer = L.geoJSON(geojson, options);
      
      let layerToAdd = new Layer(null, paramType, null, name, null, null, null, null, null);
      layerToAdd.setFileType('GeoJSON');
      layerToAdd.setLeafletLayer(geoJsonLayer);
      layerToAdd.setLayerStyle(style);
      addLayer(layerToAdd, null, false);
      
      return layerToAdd;
    },
    [addLayer]
  );
  
  // Build Turf polygon
  /**   
   * 
   * @param {[]} coordinatesPolygon      
   */
  const buildTurfObj = useCallback(
    (theme) => {
      let objTurf = null;
      if (theme.geometry.type === "MultiPolygon") {
        objTurf = turf.multiPolygon(theme.geometry.coordinates); 
      } else {
        objTurf = turf.polygon(theme.geometry.coordinates); 
      }               
      objTurf['properties'] = {
        ...theme.properties
      }
      return objTurf;  
    },
    []
  );
  
  // Build array of features theme
  /**   
   * 
   * @param {*} theme      
   */
  const buildArrFeaturesTheme = useCallback(
    (theme) => {         
      let arrPolygonsObj = [];      
      // theme.geometry.coordinates.forEach(() => {        
      //   arrPolygonsObj.push(buildTurfObj(theme));                    
      // });    
      arrPolygonsObj.push(buildTurfObj(theme));         
      return arrPolygonsObj;
    },
    [buildTurfObj]
  );

  // Calcula área total das feições
  /**
   * useCallback
   * 
   * @param {array} features      
   * @param {boolean|string} attToCalculateTotalArea 
   */
  const calculateTotalAreaTheme = useCallback(
    (features, attToCalculateTotalArea = null) => {           
      let totalAreaHa = 0;
      features.forEach((feature) => {     
        if (['Polygon', 'MultiPolygon', 'Geometry'].includes(feature.geometry.type)){
          if (attToCalculateTotalArea) {
            let featureAreaHa = Number(feature.properties[attToCalculateTotalArea]);
            if(!isNaN(featureAreaHa)) {
              totalAreaHa += featureAreaHa;
            } else {
              let areaFeature = turf.area(feature) / 10000;        
              totalAreaHa += areaFeature;  
            }  
          } else {
            let areaFeature = turf.area(feature) / 10000;          
            totalAreaHa += areaFeature;  
            feature.properties.area_ha = areaFeature.toLocaleString('pt-BR', { minimumFractionDigits: 4 }) + ' ha';
          }              
        }        
      });   

      return totalAreaHa.toLocaleString('pt-BR', { minimumFractionDigits: 4 }) + ' ha';
    },
    []
  );

  // // Calculate area from coordinates
  // /**
  //  * useCallback
  //  * 
  //  * @param {array} coordinates      
  //  */
  // const getTotalAreaFeaturesTheme = useCallback(
  //   (features) => {      
  //     let totalArea = 0;
  //     features.forEach((feature) => {  
  //       let featureAreaHa = Number(feature.properties.area_ha);
  //       if(!isNaN(featureAreaHa)) {
  //         totalArea += featureAreaHa;
  //       } else {
  //         let areaFeature = turf.area(feature);          
  //         totalArea += areaFeature;  
  //       }    
  //     });     
  //     return (totalArea).toLocaleString('pt-BR', { minimumFractionDigits: 4 }) + ' ha';                 
  //   },
  //   []
  // );

  // Add Theme on map
  /**   
   * 
   * @param {*} dataTheme      
   * @param {*} layerStyle    
   * @param {string} alias    
   * @param {boolean} withTotalAreaHaInAlias
   * @param {string} type
   */  
  const addThemeOnMap = useCallback(
    (dataTheme, layerStyle, alias, withTotalAreaHaInAlias, type) => {         
      let arrFeaturesTheme = Array.isArray(dataTheme)
                              ? dataTheme
                              : buildArrFeaturesTheme(dataTheme);      
      let canGetArea = ['Polygon', 'MultiPolygon', 'Geometry'].includes(arrFeaturesTheme[0].geometry.type);
      if (withTotalAreaHaInAlias && canGetArea) {  
        let totalAreaThemeHa = '';
        if (['string','boolean'].includes(typeof withTotalAreaHaInAlias)) {
          totalAreaThemeHa = calculateTotalAreaTheme(arrFeaturesTheme, withTotalAreaHaInAlias);
        } else {
          totalAreaThemeHa = calculateTotalAreaTheme(arrFeaturesTheme);
        }             
        alias = alias + ` - ${totalAreaThemeHa}`;
      }
      return addGeoJSONLayer(arrFeaturesTheme, layerStyle, alias, type);
    },
    [buildArrFeaturesTheme, calculateTotalAreaTheme, addGeoJSONLayer]
  );

  // Add labels to features layer
  /**
   * useCallback
   * 
   * @param {*} feature   
   * @param {string} attributeLabel
   * @param {*} customSettingsLabel
   */
  const addFeatureLabel = useCallback(
    (feature, attributeLabel, customSettingsLabel) => {            
      let settingsLabel = {
        fontColor:  '#ffffff',
        outlineColor: '#000000',          
        isFontBold: false,
        fontSize: 9,
        direction: 'center',
        opacity: 1,                
        permanent: true,
        interactive: true,
        className: 'leaflet-transparent-tooltip',        
        ...customSettingsLabel,
      };
      feature.unbindTooltip();      
      feature.bindTooltip(
        `<div style=' color:${settingsLabel.fontColor}; font-size:${
          settingsLabel.fontSize
        }px; font-weight: normal; text-shadow: -1px 0 0 ${
          settingsLabel.outlineColor
        }, -1px -1px 0 ${settingsLabel.outlineColor}, 0 -1px 0 ${
          settingsLabel.outlineColor
        }, 1px -1px 0 ${settingsLabel.outlineColor}, 1px 0 0 ${
          settingsLabel.outlineColor
        }, 1px 1px 0 ${settingsLabel.outlineColor}, 0 1px 0 ${
          settingsLabel.outlineColor
        }, -1px 1px 0 ${settingsLabel.outlineColor};'>${
          feature.feature.properties[attributeLabel]
        }</div>`,
        {          
          ...settingsLabel,
        }
      );
    },
    []
  );

  // Adiciona rótulo à camada
  /**
   * useCallback
   * 
   * @param {*} layer   
   * @param {string} attributeLabel
   * @param {*} customSettingsLabel
   */
  const applyLayerLabel = useCallback(
    (layer, attributeLabel, customSettingsLabel) => {            
      let layerSelectedLabelColumn = {
        label: attributeLabel, 
        name: attributeLabel
      }

      layer.leafletLayer.eachLayer((feature) => {              
        addFeatureLabel(feature, layerSelectedLabelColumn.label, customSettingsLabel);
      });
      changeSelectedLabelColumn(layer.id, layerSelectedLabelColumn);
      changeStatusLabelVisible(layer.id, true);
    },
    [addFeatureLabel, changeSelectedLabelColumn, changeStatusLabelVisible]
  );

  const redirectToFeedback = useCallback((withParams = true, situation, clientIp) => {      
    let paramsToRedirectAccess = 
    withParams
      ? {
        situation: situation 
                    ? situation
                    : 'Parâmetros incorretos',
        url: getURI(), 
        dateTime: getCurrentDateTimePtBr(),
        clientIp: clientIp 
                    ? clientIp
                    : '-',
      }
      : null;
    history.push(
      '/feedback/seia', 
      { 
        ...paramsToRedirectAccess,           
      }
    );
  }, [history]);

  const getURI = () => {    
    return window.location.href.split('/').slice(3).join('/');
  };

  const getCurrentDateTimePtBr = () => {    
    let localDate = new Date().toLocaleString('pt-BR');
    return localDate.substr(0, 10) + " " + localDate.substr(11, 20);
  };
  
  const loadPradDraw = useCallback(() => {
    let params = {};
    params.section = section;
    params.action = action;
    params.type = type;
    params.id = id;

    if (type === 'prad-app') {
      params.id_app = idApp;
      params.cod = cod;
    }

    params.id_loc = idLoc;
    params.token = token;

    setLoading(true);

    axios(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, {
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      if (!response.data.nome) {
        geoAlert({
          message: 'Não foi possível localizar o cadastro de Imóvel Rural informado!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      if (!response.data.limite) {
        geoAlert({
          message: 'Limite de Propriedade do Imóvel Rural não encontrado. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      if (!response.data.rl && type === 'prad-rl') {
        geoAlert({
          message: 'Poligonal da Reserva Legal não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      if (!response.data.app && type === 'prad-app') {
        geoAlert({
          message: 'Poligonal da APP não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
          callback: () => {
            window.close();
          },
        });
        return;
      }
      
      setNomeImovel(response.data.nome);
      
      // Add Layers
      addThemeOnMap(response.data.limite, layerStyles[9], `Limite de Propriedade (${id})`, false, 'importada');
      
      if (type === 'prad-rl') {
        let rl = addThemeOnMap(response.data.rl, layerStyles[11], `Reserva Legal (${id})`, false, 'importada');

        if (action === 'draw') {
          setElement('CPN-TB-D-DRAW', 'geometryLimit', response.data.rl);
          setElement('CPN-TB-D-DRAW', 'geometryLimitMessage', 'Ao menos 90% da geometria deve estar contida dentro da Reserva Legal!');
        }

        map.flyToBounds(rl.leafletLayer.getBounds());
      } else if (type === 'prad-app') {
        let app = addThemeOnMap(response.data.app, layerStyles[12], `APP (${id})`, true, 'importada');

        if (action === 'draw') {
          setElement('CPN-TB-D-DRAW', 'geometryLimit', response.data.app);
          setElement('CPN-TB-D-DRAW', 'geometryLimitMessage', 'Pelo menos 90% da geometria deve estar contida dentro da APP!');
        }

        map.flyToBounds(app.leafletLayer.getBounds());
      }
    })
    .catch((err) => {
      console.log(err);
      // err.response.status === '404'
      geoAlert({
        message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
        callback: () => {
          window.close();
        },
      });
    })
    .finally(() => setLoading(false));
  }, [addThemeOnMap, setElement, map, section, action, type, id, idLoc, token, cod, idApp]);

  const loadPradView = useCallback(() => {    
    let params = {};
    params.section = section;
    params.action = action;
    params.type = type;
    params.id = id;

    if (type === 'prad-app') {
      params.id_app = idApp;
      params.cod = cod;
    }

    params.id_loc = idLoc;
    params.token = token;

    setLoading(true);
        
    axios(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, {
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      if (!response.data.nome) {
        geoAlert({
          message: 'Não foi possível localizar o cadastro de Imóvel Rural informado!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      if (!response.data.rl && type === 'prad-rl') {
        geoAlert({
          message: 'Poligonal da Reserva Legal não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      if (!response.data.pradRL && type === 'prad-rl') {
        geoAlert({
          message: 'Poligonal da Área Degradada da Reserva Legal não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      if (!response.data.app && type === 'prad-app') {
        geoAlert({
          message: 'Poligonal da APP não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      if (!response.data.pradAPP && type === 'prad-app') {
        geoAlert({
          message: 'Poligonal da Área Degradada da APP não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      // Add Layers
      if (type === 'prad-rl') {
        //RL
        let rl = addThemeOnMap(response.data.rl, layerStyles[11], `Reserva Legal (${id})`, false, 'importada');
        
        //PRAD-RL
        let pradRL = addThemeOnMap(response.data.pradRL, layerStyles[10], `Área Degradada - Reserva Legal (${id})`, false, 'importada');

        map.flyToBounds(rl.leafletLayer.getBounds());
        map.once('moveend', function() {
          rl && rl.leafletLayer.eachLayer((feature) => {
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
          pradRL && pradRL.leafletLayer.eachLayer((feature) => {
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
        });
      } else if (type === 'prad-app') {
        //APP
        let app = addThemeOnMap(response.data.app, layerStyles[12], `APP (${id})`, true, 'importada');

        //PRAD-APP
        let pradAPP = addThemeOnMap(response.data.pradAPP, layerStyles[10], `Área Degradada - APP (${id})`, true, 'importada');

        map.flyToBounds(app.leafletLayer.getBounds());
        map.once('moveend', function() {  
          app && app.leafletLayer.eachLayer((feature) => {
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
          pradAPP && pradAPP.leafletLayer.eachLayer((feature) => {
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
        });
      }
    })
    .catch((err) => {
      console.log(err);
      // err.response.status === '404'
      geoAlert({
        message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
        callback: () => {
          window.close();
        },
      });
    })
    .finally(() => setLoading(false));    
  }, [addThemeOnMap, addFeatureLabel, map, section, action, type, id, idLoc, token, cod, idApp]);

  const loadLimiteImovel = useCallback(() => {    
    let params = {};
    params.section = section;
    params.action = action;
    params.type = type;
    params.id = id;
    params.id_loc = idLoc;
    params.token = token;

    setLoading(true);
    
    axios(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, {
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      if (!response.data.nome) {
        geoAlert({
          message: 'Não foi possível localizar o cadastro de Imóvel Rural informado!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      if (!response.data.limite) {
        geoAlert({
          message: 'Limite de Propriedade do Imóvel Rural não encontrado. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
          callback: () => {
            window.close();
          },
        });
        return;
      }

      // Add Layers
      if (type === 'imovel') {
        //Limite da Propriedade
        var limiteImovel = addThemeOnMap(response.data.limite, layerStyles[9], `Limite de Propriedade (${id})`, false, 'importada');

        //RL
        if (response.data.rl) {               
          var rl = addThemeOnMap(response.data.rl, layerStyles[11], `Reserva Legal (${id})`, false, 'importada');
        }        

        //APPS
        if (response.data.apps) {
          let appDataArr = response.data.apps;
          var arrApps = [];
          appDataArr.forEach((dataApp) => {                                    
            let app = addThemeOnMap(dataApp, layerStyles[12], `APP (${id})`, true, 'importada');
            arrApps.push(app);
          });
        }

        //PRAD-RL
        if (response.data.prad_rl) {          
          var pradRl = addThemeOnMap(response.data.prad_rl, layerStyles[10], `Área Degradada - Reserva Legal (${id})`, false, 'importada');
        }    

        //PRAD-APPS
        if (response.data.prad_apps) {
          let pradAppDataArr = response.data.prad_apps;
          var arrPradApps = [];
          pradAppDataArr.forEach((dataPradApp) => {
            let pradApp = addThemeOnMap(dataPradApp, layerStyles[10], `Área Degradada - APP (${id})`, true, 'importada');
            arrPradApps.push(pradApp);
          });
        }

        //Vegetação Nativa
        if (response.data.vn) {          
          var vn = addThemeOnMap(response.data.vn, layerStyles[14], `Vegetação Nativa (${id})`, false, 'importada');
        }

        //RPPN (Reserva Particular do Patrimônio Natural)
        if (response.data.rppn) {          
          var rppn = addThemeOnMap(response.data.rppn, layerStyles[15], `RPPN (${id})`, false, 'importada');
        }    
        
        //Área Rural Consolidada (ARC)
        if (response.data.arc) {          
          var arc = addThemeOnMap(response.data.arc, layerStyles[16], `Área Rural Consolidada (${id})`, false, 'importada');
        } 

        //Atividade Desenvolvida (ADS)
        if (response.data.ads) {
          let adsDataArr = response.data.ads;
          var arrAds = [];
          adsDataArr.forEach((dataAds) => {
            let ads = addThemeOnMap(dataAds, layerStyles[17], `Atividade Desenvolvida (${id})`, true, 'importada');
            arrAds.push(ads);
          });          
        }

        map.flyToBounds(limiteImovel.leafletLayer.getBounds());
        map.once('moveend', function() {          
          limiteImovel.leafletLayer.eachLayer((feature) => {              
            addFeatureLabel(
              feature, 
              'Área Georreferenciada (ha)', 
              {          
                fontColor: '#dbcd7c',
                outlineColor: '#000000',       
                fontSize: 10,  
              }
            );
          });
          rl && rl.leafletLayer.eachLayer((feature) => {              
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
          arrApps.forEach((app) => { 
            app.leafletLayer.eachLayer((feature) => {              
              addFeatureLabel(feature, 'Área Georreferenciada (ha)');
            });
          });          
          pradRl && pradRl.leafletLayer.eachLayer((feature) => {              
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
          arrPradApps.forEach((pradApp) => { 
            pradApp.leafletLayer.eachLayer((feature) => {              
              addFeatureLabel(feature, 'Área Georreferenciada (ha)');
            });
          });
          vn && vn.leafletLayer.eachLayer((feature) => {              
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
          rppn && rppn.leafletLayer.eachLayer((feature) => {              
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
          arc && arc.leafletLayer.eachLayer((feature) => {              
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
          arrAds.forEach((ads) => { 
            ads.leafletLayer.eachLayer((feature) => {              
              addFeatureLabel(feature, 'Área Georreferenciada (ha)');
            });
          });
        });
      } else if (type === 'app') {
        let appData = response.data.app;
        let pradAppData = response.data.pradApp;
        let app = addGeoJSONLayer(appData, layerStyles[1], 'Área de Preservação Permanente', 'importada');
        
        pradAppData && addGeoJSONLayer(pradAppData, layerStyles[2], 'Área Degradada (APP)', 'importada');

        map.flyToBounds(app.leafletLayer.getBounds());
      }
    })
    .catch((err) => {
      // err.response.status === '404'
      geoAlert({
        message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
        callback: () => {
          window.close();
        },
      });
    })
    .finally(() => setLoading(false));  
  }, [addThemeOnMap, addGeoJSONLayer, addFeatureLabel, map, section, action, type, id, idLoc, token]);

  const loadAd = useCallback(() => {    
    let params = {};
    params.section = section;
    params.action = action;
    params.type = type;
    params.id = id;
    params.id_loc = idLoc;
    params.token = token;

    setLoading(true);

    axios(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, {
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      //Atividade Desenvolvida (ADS)    
      let adDataArr = response.data.ads;      
      var arrAds = [];
      adDataArr.forEach((dataAds) => {
        let ads = addThemeOnMap(dataAds, layerStyles[13], `Atividade Desenvolvida (${id})`, true, 'importada');
        arrAds.push(ads.leafletLayer);
      });
      
      map.flyToBounds(L.featureGroup(arrAds).getBounds());
      map.once('moveend', function() {
        arrAds.forEach((ads) => { 
          ads.eachLayer((feature) => {              
            addFeatureLabel(feature, 'Área Georreferenciada (ha)');
          });
        });
      });
    })
    .catch((err) => {
      // err.response.status === '404'
      geoAlert({
        message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
        callback: () => {
          window.close();
        },
      });
    })
    .finally(() => setLoading(false)); 
  }, [addThemeOnMap, addFeatureLabel, map, section, action, type, id, idLoc, token]);

  const loadVn = useCallback(() => {    
    let params = {};
    params.section = section;
    params.action = action;
    params.type = type;
    params.id = id;
    params.id_loc = idLoc;
    params.token = token;

    setLoading(true);

    axios(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, {
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      //Vegetação Nativa      
      var vn = addThemeOnMap(response.data.vn, layerStyles[14], `Vegetação Nativa (${id})`, false, 'importada');

      map.flyToBounds(vn.leafletLayer.getBounds());    
      map.once('moveend', function() {
        vn.leafletLayer.eachLayer((feature) => {              
          addFeatureLabel(feature, 'Área Georreferenciada (ha)');
        });
      });  
    })
    .catch((err) => {      
      geoAlert({
        message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
        callback: () => {
          window.close();
        },
      });
    })
    .finally(() => setLoading(false)); 
  }, [addThemeOnMap, addFeatureLabel, map, section, action, type, id, idLoc, token]);

  const loadRppn = useCallback(() => {    
    let params = {};
    params.section = section;
    params.action = action;
    params.type = type;
    params.id = id;
    params.id_loc = idLoc;
    params.token = token;

    setLoading(true);

    axios(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, {
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {      
      //RPPN      
      var rppn = addThemeOnMap(response.data.rppn, layerStyles[15], `RPPN (${id})`, false, 'importada');

      map.flyToBounds(rppn.leafletLayer.getBounds());      
      map.once('moveend', function() {
        rppn.leafletLayer.eachLayer((feature) => {              
          addFeatureLabel(feature, 'Área Georreferenciada (ha)');
        });
      }); 
    })
    .catch((err) => {      
      geoAlert({
        message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
        callback: () => {
          window.close();
        },
      });
    })
    .finally(() => setLoading(false)); 
  }, [addThemeOnMap, addFeatureLabel, map, section, action, type, id, idLoc, token]);

  const loadArc = useCallback(() => {    
    let params = {};
    params.section = section;
    params.action = action;
    params.type = type;
    params.id = id;
    params.id_loc = idLoc;
    params.token = token;

    setLoading(true);

    axios(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, {
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      //Área Rural Consolidada (ARC)
      var arc = addThemeOnMap(response.data.arc, layerStyles[16], `Área Rural Consolidada (${id})`, false, 'importada');
      
      map.flyToBounds(arc.leafletLayer.getBounds());      
      map.once('moveend', function() {
        arc.leafletLayer.eachLayer((feature) => {              
          addFeatureLabel(feature, 'Área Georreferenciada (ha)');
        });
      }); 
    })
    .catch((err) => {
      // err.response.status === '404'
      geoAlert({
        message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
        callback: () => {
          window.close();
        },
      });
    })
    .finally(() => setLoading(false)); 
  }, [addThemeOnMap, addFeatureLabel, map, section, action, type, id, idLoc, token]);

  const loadASV = useCallback(async () => {
    let params = {};
    params.section = section;
    params.action = action;
    params.type = type;
    params.id = id;
    params.id_loc = idLoc;
    params.token = token;    

    setLoading(true);

    axios(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, {
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      if (response.data.valid) {
        redirectToFeedback(true, response.data.valid, response.data.ipCliente)
      } else {
        //Área(s) de Supressão de Vegetação
        var arrASV = [];
        var styleASVLayer = layerStyles[18];
        response.data.asv.forEach((dataASV) => {    
          if (['Point', 'MultiPoint'].includes(dataASV.geometry.type)) {            
            styleASVLayer = layerStyles[42];            
          }
          arrASV.push(addThemeOnMap(dataASV, styleASVLayer, `ASV (${dataASV.properties.origem})`, "area_ha", 'importada'));          
        });
        
        let boundLayer = L.featureGroup(arrASV.map((ip) => ip.leafletLayer)).getBounds()
        map.flyToBounds(boundLayer);        
         
        map.once('moveend', function() {
          // Adiciona rótulos nas ASV's
          arrASV.forEach((asv) => {            
            if (['MultiPolygon', 'Polygon'].includes(asv.dataType)) {
              applyLayerLabel(asv, "area_ha");
            }
          });          
        });
      }
    })
    .catch((err) => {
      // err.response.status === '404'
      geoAlert({
        message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
        callback: () => {
          window.close();
        },
      });
    })
    .finally(() => setLoading(false)); 
  }, [addThemeOnMap, applyLayerLabel, redirectToFeedback, map, section, action, type, id, idLoc, token]);
  
  const showPoint = useCallback(() => {    
    let latLng = xy.split(' ');    
    let pointTurf = turf.point([latLng[0], latLng[1]]);            
    let point = addGeoJSONLayer(pointTurf.geometry, layerStyles[36], 'Ponto', 'importada');

    map.flyToBounds(point.leafletLayer.getBounds());
    setLoading(false);
  }, [xy, addGeoJSONLayer, map]);

  // Get params from URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);    
    
    if (!urlParams.get('section') && 
        !urlParams.get('action') && 
        !urlParams.get('type') && 
        !urlParams.get('id') && 
        !urlParams.get('token')) {
          redirectToFeedback(false);          
          return;
    }

    if (!urlParams.get('section') || 
        !urlParams.get('action') ||
        !urlParams.get('type') ||
        !urlParams.get('id') ||
        !urlParams.get('token')) {
          redirectToFeedback();
          return;
    }

    setSection(urlParams.get('section'));
    setAction(urlParams.get('action') || 'view');
    setType(urlParams.get('type'));
    setId(urlParams.get('id'));
    setIdLoc(urlParams.get('id_loc'));
    setToken(urlParams.get('token'));
    setCod(urlParams.get('cod'));
    setIdApp(urlParams.get('id_app'));
    setXy(urlParams.get('xy'));
  }, [redirectToFeedback]);

  // Load Geometries from Backend
  useEffect(() => {
    if (map) {
      if(section === 'cefir') {
        // Carrega as geometrias da API
        if (action === 'draw') {
          if (type === 'prad-rl' || type === 'prad-app') { //PRAD RL ou APP
            loadPradDraw();
          }
        } else if (action === 'view') {
          if(type === 'imovel') { // Limite Propriedade
            loadLimiteImovel();
          } else if (type === 'rl') { // Reserva Legal
            //loadRl();
          } else if (type === 'app') { // Area de Preservacao Permanente
            //loadApp();
          } else if (type === 'prad-rl' || type === 'prad-app') { //PRAD RL ou APP
            loadPradView();
          } else if(type === 'ad') { // Atividade Desenvolvida
            loadAd();
          } else if(type === 'vn') { // Vegetacao Nativa
            loadVn();
          } else if(type === 'rppn') { //RPPN
            loadRppn();
          } else if(type === 'arc') { // Area Rural Consolidada
            loadArc();
          } else {
            showPoint()
          }
        }
      } else if (section === 'regulacao') {
        if (action === 'view') {
          if(type === 'asv') { // ASV
            loadASV();
          } else {
            redirectToFeedback();
            return;
          }
        } else{
          redirectToFeedback();
          return;
        }
      } else {
        redirectToFeedback();
        return;
      }
    }
  }, [loadPradDraw, loadPradView, loadLimiteImovel, loadAd, loadVn, loadRppn, loadArc, showPoint, loadASV, redirectToFeedback, map, section, action, type, token]);

  // Update degraded area
  useEffect(() => {
    let totalArea = 0;
    
    if (action === 'draw') {
      let drawedPolygons = layers.filter((l) => l.type === 'criada');

      drawedPolygons.forEach((l) => {
        let polygonGeoJson = l.leafletLayer.toGeoJSON();
        let areaPolygon = (turf.area(polygonGeoJson) / 10000).toFixed(4); //hectares (ha)
        totalArea += parseFloat(areaPolygon);
      });
    }
    setDegradedArea(totalArea);
  }, [layers, action]);

  // Save geometries to Backend
  const savePolygons = () => {
    let drawedLayers = layers.filter((l) => l.type === 'criada');
    let drawedPolygons = [];

    drawedLayers.forEach((l) => {
      l.leafletLayer.eachLayer((el) => {
        let elGeoJson = el.toGeoJSON();
        elGeoJson.geometry && drawedPolygons.push(...elGeoJson.geometry.coordinates);
      });
    });

    if (drawedPolygons.length === 0) {
      geoAlert({
        message: 'É necessário desenhar pelo menos uma poligonal!',
      });
      return;
    }

    setLoading(true);
    
    let feature = (drawedPolygons.length > 1) ? turf.multiPolygon([drawedPolygons]) : turf.polygon(drawedPolygons);
    feature.properties.id = 1;
    feature.properties.area_ha = degradedArea;

    if (type === 'prad-rl' || type === 'prad-app') {
      let bodyData = {
        section: section,
        type: type,
        id: id,
        token: token,
        feature: feature
      };

      if (type === 'prad-app') {
        bodyData.cod = cod;
      }

      axios
        .post(`${process.env.REACT_APP_API_GEOSEIA_HOST}/tema?`, bodyData, {
          headers: {
            Authorization: token,
          },
        })
        .then((response) => {
          geoAlert({
            message: 'Delimitação da Área Degradada salva com sucesso!',
            callback: () => {
              window.close();
            },
          });
        })
        .catch((err) => {
          console.log(err);
          // err.response.status === '404'
          let errMsg =
            typeof err.response.data.detail === 'string'
              ? err.response.data.detail
              : err.response.data.detail.mensagem || 'Falha ao salvar!';
          geoAlert({
            message: errMsg,
          });
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <div id="seia">
      {action === 'draw' && (type === 'prad-rl' || type === 'prad-app') && (
        <SimpleModal
          title={nomeImovel || 'Carregando...'}
          open={true}
          onClose={() => null}
          relativePosition={position}
          zIndex={1200}
          closeButton={false}
        >
          <div>
            <b>Área degradada:</b> {degradedArea} ha
          </div>
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Button variant="contained" color="primary" onClick={savePolygons}>
              Salvar
            </Button>
          </div>
        </SimpleModal>
      )}
      <GeoBahiaLoader open={loading} />
    </div>
  );
};

SEIA.properties = {
  id: 'CPN-MA-SEIA',
  alias: 'Sistema Estadual de Informações Ambientais e de Recursos Hídricos - SEIA',
  description: '...',
};

export default SEIA;
